module.exports = __webpack_public_path__ + "assets/problemfixed.ef5186bb.svg";